import { render, staticRenderFns } from "./examination-reply.vue?vue&type=template&id=318dd0eb&scoped=true"
import script from "./examination-reply.vue?vue&type=script&lang=js"
export * from "./examination-reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318dd0eb",
  null
  
)

export default component.exports